import { render, staticRenderFns } from "./cuttingPanelScanPage.vue?vue&type=template&id=2bf4db05&scoped=true&"
import script from "./cuttingPanelScanPage.vue?vue&type=script&lang=js&"
export * from "./cuttingPanelScanPage.vue?vue&type=script&lang=js&"
import style0 from "./cuttingPanelScanPage.vue?vue&type=style&index=0&id=2bf4db05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf4db05",
  null
  
)

export default component.exports